import { Factory } from "@/data/dao/Factory";
import { CookieCache } from "@/data/dao/offline/CookieCache";
import { config } from "@/data/util/Config";

import { translations } from "@/shared/localization/translations";

import { Popup } from "@/components/dialog/Popup";

export type SessionExpiredPopupSettings = {
    onConfirm?: { () };
    isAccessRightsChange?: boolean;
};

export class SessionExpiredPopup {
    static show(settings?: SessionExpiredPopupSettings) {
        Popup.show({
            title: translations.auth.sessionExpiredTitle,
            message: settings?.isAccessRightsChange
                ? translations.auth.sessionExpiredBecauseAccessRightsChangedMessage
                : translations.auth.sessionExpiredMessage,
            uniqueId: "session-expired-popup",
            containerClass: "session-expired-popup-container",

            confirmHandler: () => {
                const cookieStorage = Factory.getInstance<CookieCache>(CookieCache);
                cookieStorage.remove(config.appSessionCookieName);
                if (settings?.onConfirm) {
                    settings.onConfirm();
                }
                location.href = "/";
            },
        });
    }
}
